import React from "react";
import Card from "./card";

export default function SocialsCard(): React.ReactElement {
    return (
        <Card id={"SocialsCard"} title={"Social Media"}>
            <a className="Link" href="https://www.tiktok.com/@thealyxgreen">
                <div className={'Socials-Button'}>
                    <h3><img className="Link-Icon" alt={"TikTokIcon"} src="./images/tiktok.png"/>TikTok</h3>
                    @TheAlyxGreen
                </div>
            </a>
            <a className="Link" href="https://bsky.app/profile/the.alyx.green">
                <div className={'Socials-Button'}>
                    <h3><img className="Link-Icon" alt={"BlueSkyIcon"} src="./images/bluesky.png"/>BlueSky</h3>
                    <span>@TheAlyxGreen</span>
                </div>
            </a>
            <a className="Link" href="https://links.alyx.green">
                <div className={'Socials-Button'}>
                    <h3><img className="Link-Icon" alt={"LinksIcon"} src="./images/home.png"/>Link Site</h3>
                    <span>Links.Alyx.Green</span>
                </div>
            </a>
        </Card>
    );
}